import { render, staticRenderFns } from "./LiverCreation.vue?vue&type=template&id=0c1220a1&scoped=true"
import script from "./LiverCreation.vue?vue&type=script&lang=js"
export * from "./LiverCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1220a1",
  null
  
)

export default component.exports